import React from "react";

const SubHeading = ({ text, textColor, style }) => {
  return (
    <div
      className={`font-redhatMedium lg:text-[2.3vw] md:text-[5vw] text-[5.5vw]  text-center ${style}`}
    >
      <h3 style={{ color: textColor }}>{text}</h3>
    </div>
  );
};

export default SubHeading;
